import React from 'react'
import HomeBanner from './home/HomeBanner'
import HomeAbout from './home/HomeAbout'
import HomeServices from './home/HomeServices'
import WorkingProcess from './home/WorkingProcess'
import WhyChoose from './home/WhyChoose'
import HomeFaq from './home/HomeFaq'
import HomeOurBlog from './home/HomeOurBlog'
import Hadear from '../component/layout/Hadear'
import IndustriesServe from './home/IndustriesServe'
import HomeMission from './home/HomeMission'
import FounderMessage from './about/FounderMessage'
import OurClients from './home/OurClients'
import TurnoverGraph from './home/TurnoverGraph'



const Home = () => {
  return (
    <>
      {/* <Hadear /> */}
      <HomeBanner />
      <HomeServices />
      <HomeAbout />
      <TurnoverGraph />
      <FounderMessage />
      <HomeMission />
      <WorkingProcess />
      <WhyChoose />
      <IndustriesServe />
      <HomeFaq />
      <HomeOurBlog />
      <OurClients />







    </>
  )
}

export default Home